// extracted by mini-css-extract-plugin
module.exports = {"slick_arrow":"Slider_slick_arrow__3O_U7","next":"Slider_next__28t1a","dissabled":"Slider_dissabled__F1oub","anchor":"Slider_anchor__1KFB8","disabled":"Slider_disabled__1y5QN"};